import { render, staticRenderFns } from "./ExpenseTrend.vue?vue&type=template&id=2a77d030&"
import script from "./ExpenseTrend.vue?vue&type=script&lang=ts&"
export * from "./ExpenseTrend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports